import React from "react";
import Box from "@mui/material/Box";

function TextDisplay({ setting, styles = {} }) {
  return <Box sx={{ marginBottom: "2rem", ...styles }}>{setting.field_value}</Box>;
}

export default TextDisplay;
